// src/modules/games/components/Show/DuelTopicSelection.js
import React, { useState, useEffect } from "react";

import { navigate } from "@reach/router";
import styled from "styled-components";
// --- REQUIRED IMPORTS FOR API AND GAME LAUNCH ---
import axios from "axios"; 
import useAuth from "../../../auth/hooks/useAuth"; 

// --- ALL CORRECT IMPORTS (15 total - the ones you confirmed exist) --
import MultiplyDivide from "../../applications/MultiplyDivide/Practice.js";
import Spelling from "../../applications/Spelling/Practice.js";
import Addition from "../../applications/Addition/Practice.js";
import Fractions from "../../applications/Fractions/Practice.js";
import Grammar from "../../applications/Grammar/Practice.js";
import Geometry from "../../applications/Geometry/Practice.js";
import Measurements from "../../applications/Measurements/Practice.js";
import PlaceValue from "../../applications/NumPlace/Practice.js";
import Statistics from "../../applications/Statistics/Practice.js";
import Numerals from "../../applications/Numerals/Practice.js";
import Algebra from "../../applications/Algebra/Practice.js";
import Phonics from "../../applications/Phonics/Practice.js";
import Numbersense from "../../applications/NumberSense/Practice.js"; 
import Ratios from "../../applications/Ratios/Practice.js";
import MathsVocab from "../../applications/MathsVocab/Practice.js";
// ------------------------------------------------

import {
  TopicsContainer,
  LevelListContainer,
  GameSelectionContainer
} from "../../styled_components/containers";
import {
  Button,
  GreenButton,
  GreyedButton
} from "../../../../globals/components/button";
import Checkbox from "../../../../globals/components/Checkbox";
import { Loading } from "../../../../globals/components/loading";
import useTopics from "../../hooks/useTopics";

import RatingStats from "../../hooks/useRatingStats";
import ReactTooltip from 'react-tooltip';
import { Scale } from 'react-scaling';

// REQUIRED IMPORTS for CSV parsing
import Papa from "papaparse"; 
import additionsExtraQuestions from '../../assets/Addition/ExtraQuestions/additions_extraquestions.csv';
import numplaceExtraQuestions from '../../assets/NumberAndPlace/ExtraQuestions/numplace_extraquestions.csv';
import multiplicationExtraQuestions from '../../assets/Multiplication/ExtraQuestions/mult_extraquestions.csv';
import fractionsExtraQuestions from '../../assets/Fractions/ExtraQuestions/fractions_extraquestions.csv';
import measurementsExtraQuestions from '../../assets/Measurements/ExtraQuestions/measurement_extraquestions.csv';
import geometryExtraQuestions from '../../assets/Geometry/ExtraQuestions/geometry_extraquestions.csv';


// FIX: Corrected GAME_COMPONENTS key to "numplace"
const GAME_COMPONENTS = {
    "addition": Addition,
    "multiplication": MultiplyDivide,
    "timetables": MultiplyDivide, 
    "numplace": PlaceValue, 
    "fractions": Fractions,
    "measurement": Measurements,
    "geometry": Geometry,
    "spelling": Spelling,
    "grammar": Grammar,
    "statistics": Statistics,
    "numerals": Numerals,
    "algebra": Algebra,
    "phonics": Phonics,
    "numbersense": Numbersense,
    "ratios": Ratios,
    "mathsvocab": MathsVocab,
};


// CHANGE 1: Accept initialDuelData prop
export default function DuelTopicSelection({ game, selectedPupil, onBack, exitGame, pupil_id, initialDuelData }) { 
    
    const { topics } = useTopics({ game_type: game.game_type }, game);
    const { state: authState } = useAuth();
    
    // State for the final, combined topic structure
    const [augmentedTopics, setAugmentedTopics] = useState();
    
    const [selectedLevel, setSelectedLevel] = useState([]);
    const [selectedLevelID, setSelectedLevelID] = useState();
    // selectedTopics now holds only string topic_keys
    const [selectedTopics, setSelectedTopics] = useState([]); 
    const [selectAll, setSelectAll] = useState(false);
    
    const [isCreatingDuel, setIsCreatingDuel] = useState(false);
    const [duelCreationError, setDuelCreationError] = useState(null);
    // CHANGE 2: Initialize with initialDuelData (null for creation, object for acceptance)
    const [duelDataToLaunch, setDuelDataToLaunch] = useState(initialDuelData); 

    const MAX_TOPICS_ALLOWED = 5; 

    var ratings = RatingStats();
    const [myRating, setMyRating] = useState();
    const [addedExtraAdditions, setAddedExtraAdditions] = useState(false);
    
    // --- CSV & Topic Loading Logic (Keep this as it ensures topic.id becomes the string topic_key) ---
    
    function HasTopicAlready(tquestion, questionslist){
        for (let i = 0; i < questionslist.length; i++) {
            const element = questionslist[i];
            if (element.topic_key == tquestion.topic_key){
                return true;
            }
        }
        return false;
    }

   // Logic to transform base topics and load extra topics
   function AddExtraTopics(topicsData){
        let questionscsv = [];
        var extracsv = Papa.RemoteChunking; 

        if (topicsData === undefined || topicsData === null){
          return;
        }
        
        // CRITICAL FIX 1: Deep copy the topicsData
        const newTopics = JSON.parse(JSON.stringify(topicsData));

        // CRITICAL FIX 2: Transform all BASE topics to use string topic_key as the ID
        // This is necessary for the TopicSelection UI to track selected topics correctly
        for (const level in newTopics) {
            if (newTopics.hasOwnProperty(level) && Array.isArray(newTopics[level])) {
                newTopics[level] = newTopics[level].map(topic => {
                    // Check if the topic is a DB topic (it has an original number 'id')
                    const isNumericId = !isNaN(Number(topic.id)) && !/[a-zA-Z]/.test(String(topic.id));
                    if (topic.topic_key && isNumericId) {
                        // Store the original numerical ID under a new key for later conversion
                        topic.original_id = topic.id; 
                        // Set the ID used for UI selection/tracking to the string topic_key
                        return { ...topic, id: topic.topic_key }; 
                    }
                    if (topic.topic_key) {
                        // For non-numeric (i.e., CSV) topics, the ID is already the topic_key
                        return { ...topic, id: topic.topic_key }; 
                    }
                    return topic; 
                });
            }
        }
        
        // FIX 3: Corrected game.game_type check
        switch (game.game_type) {
            case "addition":
                extracsv = additionsExtraQuestions;
                break;
            case "numplace": 
                extracsv = numplaceExtraQuestions;
                break;
            case "multiplication":
            case "timetables":
                extracsv = multiplicationExtraQuestions;
                break;
            case "fractions":
                extracsv = fractionsExtraQuestions;
                break;
            case "measurement":
                extracsv = measurementsExtraQuestions;
                break;
            case "geometry":
                extracsv = geometryExtraQuestions;
                break;
            default:
                break;
        }

        console.log("extra csv = " + extracsv);

        if (extracsv !== Papa.RemoteChunking) {
            Papa.parse(extracsv, {
                  download: true,
                  header: true,
                  complete: function (results) {
                    console.log("Extra Questions loaded successfully.");
                    
                    let addMe = [];
                    for (let x = 0; x < results.data.length; x++) {
                        const extraQ = results.data[x];
                        if (HasTopicAlready(extraQ, addMe) == false && extraQ.topic_key != undefined){
                            let ntopic = {
                                difficulty : extraQ.difficulty,
                                // CRITICAL FIX 4: Ensure CSV topics use topic_key as ID too
                                id: extraQ.topic_key,        
                                topic_key : extraQ.topic_key, 
                                name : extraQ.topic,
                                topicname: extraQ.topic
                            };
                            addMe.push(ntopic);
                        }
                    }
                    
                    for (let i = 0; i < addMe.length; i++) {
                        const levelKey = parseInt(addMe[i].difficulty);
                        if(newTopics[levelKey]){
                            newTopics[levelKey].push(addMe[i]);
                        } else {
                            console.error(`Level ${levelKey} not found in base topics structure. Skipping CSV item.`);
                        }
                    }
                    
                    setAugmentedTopics(newTopics);
                    setAddedExtraAdditions(true);
                    console.log("done adding extra questions");
                  },
                  error: function(error, file) {
                      console.error("PapaParse ERROR: Failed to load CSV file. Falling back to base topics.", error, file);
                      setAugmentedTopics(newTopics); 
                      setAddedExtraAdditions(true);
                  }
                });
        } else {
            console.log("DEBUG: Bypassing PapaParse, no CSV file to load. Initializing augmentedTopics state.");
            setAugmentedTopics(newTopics);
            setAddedExtraAdditions(true);
        }
    }
    
    // --- Rating & Level Selection Logic ---

    function GetRating(id) {
        var myrate = -1;
        for (let i = 0; i < ratings.length; i++) {
            if (ratings[i].service_id == id) {
                myrate = ratings[i].rating;
                myrate = Math.round(myrate / 150);
                if (myrate > 10)
                    myrate = 10;
            }
        }
        return myrate;
    }

    const levels = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

    function onLevelSelect(id) {
        const topicsData = augmentedTopics || topics; 

        if (topicsData === undefined) return;
        
        const topicsSelected = topicsData[id];

        if (topicsSelected == undefined){
            if (id !== 1) {
                onLevelSelect(1); 
            }
        }else{
            topicsSelected.sort((a, b) => a.topicname.toLowerCase().localeCompare(b.topicname.toLowerCase(),'en', {numeric: true}))
            setSelectedLevelID(id);
            setSelectedLevel(topicsSelected);
            setSelectedTopics([]);
            setSelectAll(false);
        }
    }
    
    // --- Topic Selection/Deselection Logic ---
    
    function onTopicsSelect(id) {
        if (selectedTopics.length < MAX_TOPICS_ALLOWED) {
            setSelectedTopics([...selectedTopics, id]);
        } else {
            console.log(`Cannot select more than ${MAX_TOPICS_ALLOWED} topics.`);
        }
    }

    function onTopicsUnselect(id) {
        setSelectedTopics(
            selectedTopics.filter(function (value) {
                return value !== id;
            })
        );
        setSelectAll(false);
    }
    
    // --- DUEL CREATION API CALL AND GAME LAUNCH ---
    
    const handleCreateDuel = async () => {
        if (selectedTopics.length === 0 || isCreatingDuel) {
            return;
        }

        setIsCreatingDuel(true);
        setDuelCreationError(null);
        
        // The selectedTopics array now contains only string topic_keys (e.g., ["123", "CSV-T101"])
        const finalTopicKeys = selectedTopics; 
        
        console.log("DEBUG START: selectedTopics (string topic_keys):", finalTopicKeys);

        const finalGameId = game.backend_id;

        const payload = {
            opponent_pupil_id: selectedPupil.id, 
            topic_keys: finalTopicKeys, // Send the mixed string keys to the API
            game_id: finalGameId,               
        };
        
        try {
            const response = await axios({
                method: "post",
                url: `${process.env.REACT_APP_API}/duels`,
                data: payload,
                headers: {
                    Authorization: `Bearer ${authState.access_token}`,
                    "Content-Type": "application/json",
                },
            });
            
            const newDuel = response.data;
            console.log(`DUEL CREATION SUCCESS. Duel ID: ${newDuel.id} stored. Launching game.`);
            
            // newDuel will contain the topic_keys array, which matches selectedTopics
            setDuelDataToLaunch(newDuel);
            
        } catch (error) {
            console.error("DUEL CREATION FAILED", error.response ? error.response.data : error.message);
            const errorMessage = error.response 
                ? `Duel Creation Failed. Status: ${error.response.status}. Message: ${error.response.data.message || 'Server Error'}`
                : `Duel Creation Failed. Network Error: ${error.message}`;
            setDuelCreationError(errorMessage);
            
        } finally {
            setIsCreatingDuel(false);
        }
    }

    // --- Effects (No changes needed here) ---

    useEffect(() => {
        if (ratings !== undefined) {
            setMyRating(GetRating(game.id));
        }
    }, [ratings]);

    useEffect(() => {
        if (topics !== undefined && topics !== null && !addedExtraAdditions) {
            AddExtraTopics(topics); 
            return;
        }
        
        if (augmentedTopics !== undefined && myRating !== undefined && addedExtraAdditions) 
        {
            if(myRating == 1)
            {
                onLevelSelect(1);
            }
            else if(myRating > 1)
            {
                onLevelSelect(myRating);
            }
        }
    }, [topics, augmentedTopics, myRating, addedExtraAdditions]); 
    
    useEffect(() => {
        if (selectedLevel != undefined) {
            var result = selectedLevel.filter(item => selectedTopics.includes(item.id)).length;
            if (result === selectedLevel.length && result <= MAX_TOPICS_ALLOWED) {
                setSelectAll(true);
            } else {
                setSelectAll(false);
            }
        }
    }, [selectedTopics, selectedLevel]);
    
    useEffect(() => {
        if (selectedLevel.length === 0) return;
        
        if (selectAll) {
            let topicIds = [];
            selectedLevel.slice(0, MAX_TOPICS_ALLOWED).map(topic => {
                topicIds.push(topic.id);
            });
            setSelectedTopics(topicIds);
        } 
    }, [selectAll, selectedLevel]);


  function endGame() {
    console.log("endgame");
    navigate(`/games/${game.id}/duels`);
  }
    
    // --- CONDITIONAL RENDERING ---

    if (topics === undefined || augmentedTopics === undefined || !addedExtraAdditions || isCreatingDuel) {
        return <Loading />;
    }
    
   // START OF GAME LAUNCH BLOCK (Corrected Logic to match user's working component pattern)
   if (duelDataToLaunch) {
        const duelData = duelDataToLaunch; 
        const GameComponent = GAME_COMPONENTS[game.game_type] || Addition; 

        // 1. Get the list of selected string topic_keys from the Duel (e.g., ["123", "CSV-T101"])
        const topicsFromDuel = duelData.topic_keys || (duelData.topics && duelData.topics.map(t => t.topic_key))
        const mixedSelectedTopicKeys = topicsFromDuel && topicsFromDuel.length > 0 ? topicsFromDuel : selectedTopics;

        // 2. Separate the topics into the two required arrays:
        let stringTopicKeys = [];
        let mixedSelectedTopics = []; // This will be the `topics` prop (mixed Int/String)
        const allTopicsMap = {}; 

        // Populate the map using the augmentedTopics (which includes CSV items and `original_id` for DB items)
        Object.values(augmentedTopics).forEach(topicArray => {
            if (Array.isArray(topicArray)) {
                topicArray.forEach(topic => {
                    if (topic.topic_key) {
                        allTopicsMap[topic.topic_key] = topic;
                    }
                });
            }
        });

        mixedSelectedTopicKeys.forEach(selectedKey => {
            const topic = allTopicsMap[selectedKey];
            if (topic) {
                // Check if the topic is a DB topic (it has an original_id saved in AddExtraTopics)
                if (topic.original_id) {
                    // For DB topics, the 'topics' prop requires the NUMERICAL ID
                    mixedSelectedTopics.push(topic.original_id);
                } else {
                    // For CSV topics, the 'topics' prop requires the STRING KEY (topic.id == topic.topic_key)
                    mixedSelectedTopics.push(topic.id); 
                    
                    // The 'topicKeys' prop requires ALL string keys (which for CSV topics is the string key itself)
                    stringTopicKeys.push(selectedKey);
                }
            }
        });
        
        // 3. Recalculate the gameCalculations prop
        const allTopics = augmentedTopics;
        const gameCalculations = Object.entries(allTopics).reduce(
            (acc, [level, topicArray]) => {
                if (!Array.isArray(topicArray)) return acc;
                return [
                    ...acc,
                    ...topicArray.filter(topic => { 
                        // Filter using the original string keys list (mixedSelectedTopicKeys)
                        // Note: topic.id in augmentedTopics is the string topic_key
                        return mixedSelectedTopicKeys.includes(topic.id); 
                    })
                ];
            }, []
        );

        // --- FINAL DEBUG LOGS (Split Array) ---
        console.log("--- DUEL LAUNCH DEBUG START (FINAL FILTER) ---");
        console.log("topics prop (Mixed Int/String):", mixedSelectedTopics); 
        console.log("topicKeys prop (String Keys only):", stringTopicKeys); 
        console.log("--- DUEL LAUNCH DEBUG END (FINAL FILTER) ---");
        // -------------------
        
        // 4. Render the GameComponent with the corrected props based on your working pattern
        return (
            <GameComponent 
                neveragain={true}
                onBack={() => {
                    setDuelDataToLaunch(null); 
                    exitGame();
                    navigate(`/games/${game.id}/duels`);
                }}
                gameData={game} 
                isDuel={true} 
                duelData={duelData}
                pupil_id={pupil_id} 
                onDuelEnd={() => {
                  setDuelDataToLaunch(null); 
                    exitGame();
                    navigate(`/games/${game.id}/duels`);
                }}
                level={selectedLevelID}
                // FIXED: Pass the mixed array of INT IDs and STRING keys
                topics={mixedSelectedTopics}       
                gameType={game.game_type}       
                // FIXED: Pass the array of STRING keys only
                topicKeys={stringTopicKeys}      
                gameCalculations={gameCalculations} 
                timelimit={120}
                gameBackground={game.practice_background}
            />
        );
    }
    // END OF GAME LAUNCH BLOCK

    // 3. Render Topic Selection Screen
    return (
        <TopicsContainer lv={selectedLevel}>
            {selectedLevel != undefined ? (

              <Scale scaleTo={1720}>
                <div>
                  <GameSelectionContainer>
                    <h1>Select Topics to Challenge {selectedPupil ? selectedPupil.username : 'Pupil'}</h1>
                    
                    {/* Checkbox for Select All */}
                    {selectedLevel.length > 0 && (
                      <Checkbox
                        label="Select All"
                        bold={true}
                        onChange={e => {
                          setSelectAll(e.target.checked);
                        }}
                        checked={selectAll}
                        disabled={!selectAll && selectedLevel.length > MAX_TOPICS_ALLOWED}
                      />
                    )}
                    
                    {/* List of Topics */}
                    {selectedLevel.length > 0 &&
                      selectedLevel.map(topic => {
                        const isSelected = selectedTopics.includes(topic.id);
                        const isDisabled = !isSelected && selectedTopics.length >= MAX_TOPICS_ALLOWED;
                        
                        return (
                          <Checkbox
                            key={topic.id}
                            label={topic.topicname}
                            onChange={e => {
                              if (e.target.checked === true) {
                                onTopicsSelect(topic.id);
                              } else {
                                onTopicsUnselect(topic.id);
                              }
                            }}
                            checked={isSelected}
                            disabled={isDisabled}
                          />
                        );
                      })}
                      {selectedLevel.length == 0 &&
                      <h1 style= {{ color: "red" }}>Please select a level</h1>}
                      
                      {/* TOPIC LIMIT WARNING */}
                      {selectedTopics.length >= MAX_TOPICS_ALLOWED && 
                        <h4 style={{ color: "red", marginTop: "10px" }}>Maximum {MAX_TOPICS_ALLOWED} topics selected.</h4>
                      }
                      
                      {/* ERROR MESSAGE */}
                      {duelCreationError && (
                          <h4 style={{ color: "red", marginTop: "10px", padding: '10px', border: '1px solid red' }}>
                              {duelCreationError}
                          </h4>
                      )}
                      
                  </GameSelectionContainer>
                  
                  <div>
                    {selectedTopics.length > 0 ? (
                      <GreenButton
                        style={{ width: "20%" }}
                        onClick={handleCreateDuel}
                        disabled={isCreatingDuel}
                      >
                        Create Duel
                      </GreenButton>
                    ) : (
                        <GreyedButton data-tip="You need to add a topic to practice" style={{ width: "20%" }}>Create Duel</GreyedButton>
                      )}
                      
                    {/* Level Selection */}
                    <LevelListContainer style={{ marginBottom: "50px" }}>
                      {(levels &&
                          levels.map(level => {
                            if (myRating == 10) {
                              return (
                                <LevelButton
                                  key={level}
                                  style={{ marginTop: "5px" }}
                                  onClick={() => onLevelSelect(level)}
                                  active={level === selectedLevelID}
                                >
                                  <div>
                                    <h4>Level {level}</h4>
                                    </div>
                                </LevelButton>
                              );
                            }
                            else if (myRating > 1) { 
                              if (myRating == level || (myRating - 1) == level) {
                                return (
                                  <LevelButton
                                    key={level}
                                    style={{ marginTop: "5px" }}
                                    onClick={() => onLevelSelect(level)}
                                    active={level === selectedLevelID}
                                  >
                                    <div>
                                      <h4>Level {level}</h4>
                                    </div>
                                  </LevelButton>
                                );
                              }
                              else {
                                return (
                                  <LevelButton
                                    key={level}
                                    data-tip="too high or havent unlocked" style={{ marginTop: "5px", background: "grey", border: "2px solid #a0a0a0" }}
                                  >
                                    <div>
                                      <h4>Level {level}</h4> 
                                    </div>
                                  </LevelButton>
                                );
                              }
                            }
                            else {
                              if (myRating == level || level == 1) {
                                return (
                                  <LevelButton
                                    key={level}
                                    style={{ marginTop: "5px" }}
                                    onClick={() => onLevelSelect(level)}
                                    active={level === selectedLevelID}
                                  >
                                    <div>
                                      <h4>Level {level}</h4>
                                    </div>
                                  </LevelButton>
                                );
                              }
                              else {
                                return (
                                  <LevelButton
                                    key={level}
                                    data-tip="too high or havent unlocked" style={{ marginTop: "5px", background: "grey", border: "2px solid #a0a0a0" }}
                                  >
                                    <div>
                                      <h4>Level {level}</h4> 
                                    </div>
                                  </LevelButton>
                                );
                              }

                            }
                          }))}
                      <Tools className='extra' />
                    </LevelListContainer>
                  </div>
                </div>
              </Scale>
            ) : (
                <div>
                </div>
              )}
              
              <Buttonz onClick={onBack}>Back</Buttonz>
          </TopicsContainer>
    );
}

// --- Styled components (Full Definitions) ---

const Buttonz = styled.button`
  background: rgb(234, 146, 19);
  background: linear-gradient(
    0deg,
    rgba(234, 146, 19, 1) 0%,
    rgba(255, 186, 32, 1) 100%
  );
  width: 20%;
  border: 2px solid #e88f12;
  color: #fff;
  user-select: none;
  padding: 0.5em;
  margin: -0.5em 0;
  box-sizing: border-box;
  border-radius: 0.25em;
  font-size: 3em;
  cursor: pointer;
  @media (min-width: 1025px) and (max-width: 1440px) {
    font-size: 2.5em;
  }

  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
    margin-bottom: 0;
  }
`

const Tools = styled(ReactTooltip)`
  font-size: 20px !important;
  background-color: #543171FF !important;
  `

const LevelButton = styled(Button)`
    text-align: center;
    width: 10%;
    height: 70px;
    margin: 5px;
    color: #fff;
    user-select: none;
    background: ${props => (props.active ? "#673b8b," : "rgb(234, 146, 19)")};
    background: ${props =>
    props.active
      ? "linear-gradient(0deg, #673b8b, #683d8c)"
      : "linear-gradient(0deg,rgba(234, 146, 19, 1) 0%,rgba(255, 186, 32, 1) 100%)"};
    border: 2px solid ${props => (props.active ? "#673b8b" : "#e88f12")};

    padding: 0.5em;
    box-sizing: border-box;
    border-radius: 0.25em;
    font-size: 3em;
    cursor: ${props => (props.active ? "pointer" : "")};
    @media (min-width: 1025px) and (max-width: 1440px) {
        font-size: 2.5em;
    }

    @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
        margin-bottom: 0;
    }
`;